import type { Product } from '@/components/ProductModal'
import i18n from '@/i18n'

// Base product data — structural fields only (non-translatable)
const productsBase: Omit<Product, 'name' | 'description' | 'subcategory' | 'format' | 'ingredients' | 'badges'>[] = [
  // === PANETTONI ===
  { id: 1, category: 'panettoni', image: '/images/products/panettone-classico.png', weight: '1 kg', isClassic: true },
  { id: 2, category: 'panettoni', image: '/images/products/panettone-cioccolato.png', weight: '1 kg' },
  { id: 3, category: 'panettoni', image: '/images/products/panettone-classico.png', weight: '1 kg' },
  { id: 4, category: 'panettoni', image: '/images/products/panettone-classico.png', weight: '750 g', isClassic: true },
  { id: 5, category: 'panettoni', image: '/images/products/panettone-classico.png', weight: '1 kg', isClassic: true },
  { id: 6, category: 'panettoni', image: '/images/products/panettone-classico.png', weight: '100 g x 6' },
  { id: 7, category: 'panettoni', image: '/images/products/panettone-classico.png', weight: '750 g' },
  { id: 8, category: 'panettoni', image: '/images/products/panettone-classico.png', weight: '1 kg', isNew: true },
  { id: 9, category: 'panettoni', image: '/images/products/panettone-classico.png', weight: '1 kg', isClassic: true },
  { id: 10, category: 'panettoni', image: '/images/products/panettone-classico.png' },
  // === COLOMBE ===
  { id: 11, category: 'colombe', image: '/images/products/colomba-classica.png', weight: '1 kg', isClassic: true },
  { id: 12, category: 'colombe', image: '/images/products/colomba-cioccolato.png', weight: '1 kg' },
  { id: 13, category: 'colombe', image: '/images/products/colomba-cioccolato.png', weight: '750 g', isNew: true },
  { id: 14, category: 'colombe', image: '/images/products/colomba-classica.png', weight: '750 g' },
  { id: 15, category: 'colombe', image: '/images/products/colomba-classica.png', weight: '100 g x 6' },
  { id: 16, category: 'colombe', image: '/images/products/colomba-classica.png', weight: '1,5 kg' },
  { id: 17, category: 'colombe', image: '/images/products/colomba-classica.png', weight: '1 kg' },
  { id: 18, category: 'colombe', image: '/images/products/colomba-cioccolato.png', weight: '1 kg', isNew: true },
  // === PASTICCERIA ===
  { id: 19, category: 'pasticceria', image: '/images/products/biscotti.png', weight: '200 g' },
  { id: 20, category: 'pasticceria', image: '/images/products/biscotti.png', weight: '200 g' },
  { id: 21, category: 'pasticceria', image: '/images/products/biscotti.png', weight: '150 g', isClassic: true },
  { id: 22, category: 'pasticceria', image: '/images/products/biscotti.png', weight: '200 g' },
  { id: 23, category: 'pasticceria', image: '/images/products/biscotti.png', weight: '200 g' },
  { id: 24, category: 'pasticceria', image: '/images/products/biscotti.png', weight: '200 g' },
  { id: 25, category: 'pasticceria', image: '/images/products/biscotti.png', weight: '250 g' },
  { id: 26, category: 'pasticceria', image: '/images/products/biscotti.png', weight: '200 g' },
  { id: 27, category: 'pasticceria', image: '/images/products/torta-nocciole.png', weight: '200 g', isClassic: true },
  { id: 28, category: 'pasticceria', image: '/images/products/biscotti.png', weight: '150 g', isClassic: true },
  { id: 29, category: 'pasticceria', image: '/images/products/biscotti.png', weight: '200 g' },
]

function getTranslatedProduct(base: typeof productsBase[number]): Product {
  const t = i18n.t.bind(i18n)
  const key = `productData.${base.id}`
  return {
    ...base,
    name: t(`${key}.name`, { ns: 'common' }),
    description: t(`${key}.description`, { ns: 'common' }),
    subcategory: t(`${key}.subcategory`, { ns: 'common', defaultValue: '' }) || undefined,
    format: t(`${key}.format`, { ns: 'common', defaultValue: '' }) || undefined,
    ingredients: i18n.exists(`${key}.ingredients`, { ns: 'common' })
      ? (t(`${key}.ingredients`, { ns: 'common', returnObjects: true }) as string[])
      : undefined,
    badges: i18n.exists(`${key}.badges`, { ns: 'common' })
      ? (t(`${key}.badges`, { ns: 'common', returnObjects: true }) as string[])
      : undefined,
  }
}

export const getProducts = (): Product[] => {
  return productsBase.map(getTranslatedProduct)
}

export const getProductById = (id: number): Product | undefined => {
  const base = productsBase.find(p => p.id === id)
  if (!base) return undefined
  return getTranslatedProduct(base)
}

export const getProductsByCategory = (category: string): Product[] => {
  const bases = category === 'all' ? productsBase : productsBase.filter(p => p.category === category)
  return bases.map(getTranslatedProduct)
}
